import { Box, Typography } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { useAppContext } from '../../contexts/AppContext';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';
import { useEffect } from 'react';

// Component to update map view when coordinates change
const MapUpdater = ({ center }: { center: [number, number] }) => {
  const map = useMap();

  useEffect(() => {
    map.setView(center);
  }, [center, map]);

  return null;
};

const Map = ({ mapRef, field }) => {
  const { formData } = useFormContext();
  const { isDarkMode } = useAppContext();

  const zoom = 13;

  // Validate that coordinates are valid numbers
  const isValidCoordinate = (coord: any) => {
    return coord !== null && coord !== undefined && coord !== '' && !isNaN(Number(coord));
  };

  const hasValidCoordinates =
    formData.location?.latitude &&
    formData.location?.longitude &&
    isValidCoordinate(formData.location.latitude) &&
    isValidCoordinate(formData.location.longitude);

  const center: [number, number] = [Number(formData.location?.latitude || 0), Number(formData.location?.longitude || 0)];

  return hasValidCoordinates ? (
    <Grid size={field.size || 12} key={field.name}>
      <Box className={isDarkMode ? 'dark-map' : ''}>
        <MapContainer
          ref={mapRef}
          center={center}
          zoom={zoom}
          style={{ width: '100%', height: '400px' }}
          attributionControl={false}
          scrollWheelZoom={false}
        >
          <MapUpdater center={center} />
          <TileLayer url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}" maxZoom={20} subdomains={['mt1', 'mt2', 'mt3']} />

          <Marker position={center}>
            <Popup>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2" sx={{ margin: 1, fontWeight: 'bold' }}>
                  {formData.name}
                </Typography>
              </Box>
            </Popup>
          </Marker>
        </MapContainer>
      </Box>
    </Grid>
  ) : null;
};

export default Map;
